export const FETCH_WAREHOUSES_START = 'warehouses/FETCH_WAREHOUSES_START';
export const FETCH_WAREHOUSES_SUCCESS = 'warehouses/FETCH_WAREHOUSES_SUCCESS';
export const FETCH_WAREHOUSES_FAILURE = 'warehouses/FETCH_WAREHOUSES_FAILURE';

export const SAVE_WAREHOUSES_START = 'warehouses/SAVE_WAREHOUSES_START';
export const SAVE_WAREHOUSES_SUCCESS = 'warehouses/SAVE_WAREHOUSES_SUCCESS';
export const SAVE_WAREHOUSES_FAILURE = 'warehouses/SAVE_WAREHOUSES_FAILURE';
